import { useToasts } from "react-toast-notifications";
import NacionalidadeGrid from "./NacionalidadeGrid";
import { Form, FormGroup } from "rsuite";

export default function Nacionalidade() {
  const { addToast } = useToasts();

  function successMessage(message) {
    addToast(message, {
      appearance: "success",
      autoDismiss: true,
    });
  }

  function warningMessage(message) {
    addToast(message, {
      appearance: "warning",
      autoDismiss: true,
    });
  }

  return (
    <div className="pageContainer">
      <div className="pageFlex">
        <div className="pageContent withoutSearch w650">
          <h4>Nacionalidade</h4>
          <Form className="pageForm">
            <FormGroup
              className="pageFormContainer"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <NacionalidadeGrid
                successMessage={successMessage}
                warningMessage={warningMessage}
              />
            </FormGroup>
          </Form>
        </div>
      </div>
    </div>
  );
}
